{
  "version": 1,
  "asset_id": "39c726dd-f96d-4e3f-89bf-bc2290e73db3",
  "project_id": "e692c292-fbeb-41e1-8213-5a4529ec6f58",
  "url": "/__l5e/assets-v1/39c726dd-f96d-4e3f-89bf-bc2290e73db3/codelco.png",
  "r2_key": "a/v1/e692c292-fbeb-41e1-8213-5a4529ec6f58/39c726dd-f96d-4e3f-89bf-bc2290e73db3/codelco.png",
  "original_filename": "codelco.png",
  "size": 20415,
  "content_type": "image/png",
  "created_at": "2026-07-10T03:51:03Z"
}
